// Paths where offline mutations are supported (stoppages, truck loads, digging patterns).
// All other paths show the offline-unavailable guard when the user has no connection.
export const OFFLINE_CAPABLE_PATHS: ReadonlySet<string> = new Set([
  '/',
  '/operations',
  '/stoppages',
  '/production/list',
  '/production/show',
  '/production/rehandle',
  '/production/crushing',
])
